import Link from 'next/link';

import CoursesImg from '@core/assets/images/mobile-menu-courses.png';
import CareerImg from '@core/assets/images/mobile-menu-career.png';
import classes from './ExploreMenu.module.scss';


const ExploreMenu = ({closeHandler}) => {
    return (
        <div className={classes.wrapper}>
            <Link onClick={closeHandler} href='/explore?featured_contents=true&content=lecture' >
                <div className={`d-flex align-items-center gap-3 ${classes.course}`}>
                    <img src={CoursesImg.src} alt='' />
                    <div>
                        <h4>Explore Courses</h4>
                        <p>Earn career credentials from industry leaders that demonstrate your expertise.</p>
                    </div>
                </div>
            </Link>
            <Link onClick={closeHandler} href='/career-path'>
                <div className={`d-flex align-items-center gap-3 ${classes.career}`}>
                    <img src={CareerImg.src} alt='' />
                    <div>
                        <h4>Explore Career Paths</h4>
                        <p>Pick a career path, follow its guided course roadmap, and secure industry-verified credentials in a few months.</p>
                    </div>
                </div>
            </Link>
        </div>
    );
}

export default ExploreMenu;